import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { PageLayout } from '@/components/Layout/PageLayout';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <PageLayout title="Terms & Conditions" maxWidth="2xl">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <div className="flex items-center gap-3 mb-4">
            <FileText className="w-6 h-6 text-primary" />
            <h2 className="text-xl font-semibold">Terms of Use</h2>
          </div>

          <div className="space-y-4 text-base leading-relaxed text-foreground/80">
            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Service Provision</h3>
              <p>
                  Wren is provided "as is" for personal expense tracking use. We strive to keep 
                the service available and reliable, but cannot guarantee uninterrupted access.
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">User Responsibilities</h3>
              <p>
                  By using Wren, you agree to use the service responsibly and in accordance with 
                applicable laws. You are responsible for maintaining the security of your account credentials.
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Privacy Agreement</h3>
              <p>
                By using this service, you agree to our Privacy Policy. Your data is collected and stored 
                as described in the Privacy Policy document.
              </p>
            </div>


            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Limitation of Liability</h3>
              <p>
                  Wren is not responsible for any financial decisions made based on data tracked 
                in the app. The app is a tracking tool and does not provide financial advice.
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Not Financial Advice</h3>
              <p>
                  Wren is a tool for personal expense tracking and awareness. 
                It does not provide financial, investment, tax, or legal advice. 
                The app's features (including budgets, insights, and statistics) are for 
                informational purposes only. Always consult qualified professionals for 
                financial decisions.
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Changes to Terms</h3>
              <p>
                We reserve the right to modify these terms at any time. Continued use of the service 
                after changes constitutes acceptance of the modified terms.
              </p>
            </div>
          </div>

          <div className="pt-4 border-t text-sm text-muted-foreground">
            Last updated: January 2025
          </div>
        </Card>

        <Button 
          variant="outline" 
          className="w-full"
          onClick={() => navigate('/privacy')}
        >
          View Privacy Policy
        </Button>
      </div>
    </PageLayout>
  );
}